import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"

const WoningContact = (props) => {
   const vestiging = props.vestiging
   const status = props.status
   const contactpersoon  = props.contactpersoon
   const sellerData = props.seller
   const image = props.image !== null ? props.image : null

   let seller = null
   seller = sellerData?.nodes?.filter((sell) => {
      return sell.title === contactpersoon;
    })

    const sellerName = seller?.length > 0 ? seller[0].title : ''
    const sellerVestiging = seller?.length > 0 ? `` : `Groenhout ${vestiging}`
    const phoneNumber = seller?.length > 0 ? seller[0].verkopendeMakelaars.telefoonnummer : ''
    const sellerImage = seller?.length > 0 ? getImage(seller[0].verkopendeMakelaars.foto?.localFile) : ''
    const phoneDisplay = phoneNumber !== '' && phoneNumber.startsWith('06') ? phoneNumber.substr(0,2) + ' - ' + phoneNumber.substr(2) :  phoneNumber !== '' && !phoneNumber.startsWith('06') ? phoneNumber.substr(0,4) + ' - ' + phoneNumber.substr(4) : null  
    const emailAddress = seller?.length > 0 ? seller[0].verkopendeMakelaars.emailadres : ''

    const scroll = props.scrollHandler

    return (
      <div className="w-full sticky top-40">
        <div>
          {image !== undefined ? (
            // <GatsbyImage image={image} alt={''} />
            <img src={image} className="object-cover w-full h-auto"></img>
          ) : null}
          <GatsbyImage
            image={sellerImage}
            className="absolute rounded-full w-3/12 top-40 right-8"
          ></GatsbyImage>
        </div>
        <div className="py-5">
          <span className="text-blue text-lg font-bold ">
            {props.origin !== null
              ? `Ook opzoek naar een woning?`
              : `Geïnteresseerd in deze woning?`}
          </span>
          <p className="text-blue mt-5">
            {status === "Beschikbaar" || status === "Onder bod" ? (
              "Alles wat je wilt weten, vind je in onze brochure."
            ) : (
              <>
                Neem contact op met {sellerName} {sellerVestiging}{" "}
                <a
                  target="_blank"
                  href={`tel:${phoneNumber
                    .replace(/\s/g, "")
                    .replace("-", "")}`}
                >
                  <span className="text-red">{phoneDisplay}</span>
                </a>
              </>
            )}
          </p>
          {phoneNumber !== "" && emailAddress !== "" ? (
            <div className="flex flex-row justify-around text-blue">
              <a
                target="_blank"
                href={`https://api.whatsapp.com/send/?phone=31${phoneNumber
                  .replace(/\s/g, "")
                  .replace("-", "")}`}
              >
                <FontAwesomeIcon icon={faWhatsapp} size="lg" />
              </a>
              <a
                target="_blank"
                href={`tel:${phoneNumber.replace(/\s/g, "").replace("-", "")}`}
              >
                <FontAwesomeIcon icon={faPhone} size="lg" />
              </a>
              <a target="_blank" href={`mailto:${emailAddress}`}>
                <FontAwesomeIcon icon={faEnvelope} size="lg" />
              </a>
            </div>
          ) : null}
          <span
            onClick={() => scroll()}
            className="text-light bg-red hover:bg-blue p-4 mt-8 flex flex-row justify-center cursor-pointer"
          >
            <span>
              {props.button !== undefined ? props.button : "Brochure aanvragen"}
            </span>
          </span>
        </div>
      </div>
    )
}

export default WoningContact;